import React, { useState } from "react";
import logo from "../img/helibrowsLogo.svg";

import "../style/navbar.scss";
import LinkButton from "./LinkButton";

export default function Navbar() {
  const [openNav, setOpenNav] = useState(false);

  return (
    <header>
      <div className="wrapper">
        <nav data-aos="fade-down">
          <a href="/">
            <img src={logo} alt="Heli Brows | Logo" />
          </a>
          <ul className={`${openNav ? "active" : ""}`}>
            <div onClick={() => setOpenNav(!openNav)} className="close-mobile">
              <div>zatvori</div>
            </div>
            <li>
              <a href="/">Početna</a>
            </li>
            <li>
              <a href="/o-meni">O meni</a>
            </li>
            <li>
              <a href="/galerija-radova">Galerija</a>
            </li>
            <li>
              <a href="/puder-obrve">Puder obrve</a>
            </li>
            <li>
              <a href="/kontakt">Kontakt</a>
            </li>
            <li>
              <a href="/najcesce-postavljena-pitanja">FAQ</a>
            </li>

            <div className="contact-info">
              <span>Kontaktiraj me</span>
              <div>
                <a href="mailto:info@helibrows.rs">info@helibrows.rs</a>
              </div>
              <div>
                <a href="https://www.instagram.com/heli_brows/">@heli_brows</a>
              </div>
              <div>
              <a href="https://www.tiktok.com/@heli_brows" target="_blank" rel="noreferrer">heli_brows</a>
              </div>
            </div>
          </ul>
          <div className="menu-btn">
            <LinkButton link="/kontakt" buttonText="Besplatna konsultacija" />

            <div onClick={() => setOpenNav(!openNav)} className="menu-burger">
              <div />
              <div />
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
}
